export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center">
            <i className="ri-information-line text-3xl text-primary-600"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-4">
            关于91吃瓜
          </h2>
          <div className="max-w-2xl mx-auto">
            <p className="text-sm text-foreground-600 leading-relaxed mb-3">
              91吃瓜创立于2021年，是国内领先的娱乐八卦与热点资讯导航平台。我们致力于为吃瓜群众提供91吃瓜网、91吃瓜在线、91吃瓜官网等最新入口的一站式导航服务，让每一位用户都能快速、稳定地访问心仪的吃瓜平台。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-3">
              平台覆盖明星八卦、影视综艺、网红动态、社会热点等多个领域，每日更新超过200条新鲜资讯。我们的编辑团队由资深娱乐媒体人组成，以客观、及时、全面的报道态度，为广大吃瓜爱好者打造一个高效、可靠的信息聚合入口。
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              无论你是想了解最新娱乐动态，还是追踪热门八卦事件，91吃瓜都将是你的不二之选。我们相信，吃瓜不仅是一种娱乐方式，更是一种生活态度——在这个信息爆炸的时代，91吃瓜帮你筛选最有料的内容，让你吃得开心、吃得明白。
            </p>
          </div>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-6">
            <div className="text-center">
              <p className="text-2xl font-bold text-primary-600">4年+</p>
              <p className="text-xs text-foreground-400 mt-1">稳定运营</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-accent-600">200+</p>
              <p className="text-xs text-foreground-400 mt-1">日均更新</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-secondary-600">12类</p>
              <p className="text-xs text-foreground-400 mt-1">内容覆盖</p>
            </div>
            <div className="text-center">
              <p className="text-2xl font-bold text-primary-600">百万+</p>
              <p className="text-xs text-foreground-400 mt-1">月活跃用户</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}